<script setup lang="ts">
import { computed, reactive } from "vue";
import StopInfoPipForm from "@/views/trips/components/forms/StopInfoPipForm.vue";
import { usePipStore } from "@/store/pip.store";
import { getStopVerifyTitle } from "@/utils/stopInfoTitle";
import type { StopInfoPipProps } from "@/types/props";
import type { RouteStopDto, TripDto, TripRouteDto } from "@/api/trips/dto/trip.dto";

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    trip: TripDto;
    route: TripRouteDto;
    stop: RouteStopDto;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const emit = defineEmits<{
  (e: "load"): void;
}>();

const pipStore = usePipStore();

const title = computed<string>(() => getStopVerifyTitle(props.stop));

const pipProps = reactive<StopInfoPipProps>({
  get trip() {
    return props.trip;
  },
  get route() {
    return props.route;
  },
  get stop() {
    return props.stop;
  },
  get title() {
    return title.value;
  },
});

async function showLoadVerification(): Promise<void> {
  await pipStore.open({
    component: StopInfoPipForm,
    props: pipProps,
    on: {
      save,
      close: () => pipStore.close(),
    },
  });
}

function save(): void {
  emit("load");
}
</script>

<template>
  <v-btn :disabled="disabled" block v-bind="$attrs" variant="flat" @click="showLoadVerification">
    Load and verify
  </v-btn>
</template>

<style lang="scss" scoped></style>
